<template>
  <div class="zy-health rescue-page">
    <!-- 顶部导航栏 -->
    <header class="rescue-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <button 
          class="nav-back-btn" 
          @click="goBack"
          :style="{top: pageBackBtnTop + 'px'}"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <div class="nav-title">一键救援</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="rescue-content" :style="rescueContentStyle">
      <!-- 紧急信息横幅 -->
      <div class="rescue-banner">
        <div class="banner-text">
          <div class="banner-line1">中国公民突发重病、</div>
          <div class="banner-line2">突发重伤特别救援通道。</div>
        </div>
        <div class="banner-arrow"></div>
      </div>

      <!-- 用户和位置信息 -->
      <div class="rescue-user-info">
        <div class="user-info-left">
          <div class="app-icon-wrapper">
            <div class="app-icon">
              <img src="@/assets/login/Headicon.png" alt="大救星" class="app-icon-img" />
            </div>
            <!-- <div class="app-version">健康版</div> -->
          </div>
        </div>
        <div class="user-info-right">
          <div class="user-phone">用户{{ maskedPhone }}</div>
          <div class="location-info">
            <span class="location-text" :class="{ 'location-text-loading': addressLoading }">
              位置:{{ addressLoading ? '获取详细地址中...' : baiduAddress }}
            </span>
            <i class="el-icon-location location-icon"></i>
          </div>
          <!-- <div v-if="baiduLocation" class="location-detail"> -->
            <!-- <div class="location-detail-row">
              <span class="detail-label">经纬度：</span>
              <span class="detail-value">{{ baiduLocation.lng }}, {{ baiduLocation.lat }}</span>
            </div> -->
            <!-- <div v-if="baiduAddress" class="location-detail-row">
              <span class="detail-label">地址：</span>
              <span class="detail-value">{{ baiduAddress }}</span>
            </div> -->
          <!-- </div> -->
        </div>
      </div>

      <!-- 倒计时区域 -->
      <div class="rescue-countdown" :class="{ 'rescue-countdown--compact': showMainCountdown }">
        <div v-if="showMainCountdown" class="main-countdown">
          <div class="countdown-number">{{ countdown }}</div>
          <div class="countdown-unit">秒</div>
        </div>
        <div v-else class="pre-countdown-text">
          获取详细地址后将开启倒计时
        </div>
      </div>

      <!-- 说明文字 -->
      <div class="rescue-disclaimer">
        倒计时结束后,大救星将为您启动一键救援服务。请您提供真实有效的救助信息,否则将影响求助效果并承担法律责任。
      </div>

      <!-- 倒计时进行中：取消按钮（文档流，避免遮挡说明文字） -->
      <div v-if="showMainCountdown" class="rescue-cancel-wrap">
        <button type="button" class="rescue-cancel-btn" @click="cancelRescue">取消一键救援</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import { useUserStore } from '@/stores/user';
import { findAddress, submitRescue, getEquityUsedCount } from '@/api/activity';
import {
  buildRescueEquityPayload,
  loadRescueEquityInfo,
  clearRescueEquityInfo,
  normalizeBillingType
} from '@/utils/equityCaseType';

export default {
  name: 'Rescue',
  data() {
    return {
      countdown: 5, // 主倒计时（5秒）
      showMainCountdown: false,
      countdownTimer: null,
      baiduLocation: null, // 当前使用的坐标（GCJ-02）
      baiduAddress: '正在获取中...', // 详细地址
      addressResolved: false, // 是否已获取到可用详细地址
      addressLoading: true, // 是否正在获取详细地址（用于样式）
      /** @type {Object|null} 权益使用统计（服务入口透传至救援接口） */
      equityUsedInfo: null
    };
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight', 'pageContentTop', 'pageBackBtnTop']),
    ...mapState(useUserStore, ['userInfo']),
    /**
     * 获取脱敏后的手机号
     */
    maskedPhone() {
      const phone = this.userInfo.userPhone || this.userInfo.phone || '';
      if (phone && phone.length >= 11) {
        return phone.substring(0, 3) + '****' + phone.substring(7);
      }
      return phone || '***';
    },
    /**
     * 内容区样式（含底部安全区，保证说明与取消按钮均可完整展示）
     * @returns {{ paddingTop: string, paddingBottom: string }}
     */
    rescueContentStyle() {
      return {
        // 与监测页 health-monitoring-dashboard 一致：标题下再留 12px
        paddingTop: this.pageContentTop + 12 + 'px',
        paddingBottom: `calc(24px + env(safe-area-inset-bottom, 0px))`
      };
    },
    /**
     * 一键救援案件类型 caseType（对应权益项 source_id / productConfigId）
     * - 首页「一键救援」进入：query.caseType = 110
     * - newIndex 二级服务页进入：query.caseType = 该页对应权益 caseType（如 955）
     * - 其它未传场景：兜底 110
     * @returns {string}
     */
    rescueCaseType() {
      const fromQuery = this.$route.query.caseType
      if (fromQuery != null && String(fromQuery).trim() !== '') {
        return String(fromQuery).trim()
      }
      // 首页/其它入口未带 caseType 时，按文档默认一键救援 110
      return '110'
    }
  },
  created() {
    // 服务入口：优先读取二级页暂存的权益统计；缺失时再按 productId + caseType 补查
    this.initEquityUsedInfo();
  },
  mounted() {
    // 设置页面背景色
    document.body.style.backgroundColor = '#F2F3F5';

    // iOS 环境：注册供原生调用的回调，用于接收 getCoordinates 返回的坐标
    if (this.$env && this.$env.inDjxApp && this.$env.inIos) {
      window.iosCoordinates = this.iosCoordinates.bind(this);
    }
    // Android App：注册供原生调用的回调，用于接收 getCoordinates 返回的坐标
    if (this.$env && this.$env.inDjxApp && this.$env.inAndroid) {
      window.iosCoordinates = this.iosCoordinates.bind(this);
    }

    /**
     * 注意：Android 在 checkCallHelpPermission 后可能会立刻回调 H5（window.androidCoordinates）。
     * 因此必须先注册回调，再等待页面挂载完成后再触发原生权限检查，避免回调丢失。
     */
    this.$nextTick(() => {
      // 再延迟一帧，确保 WebView 侧注入/回调链路稳定（部分机型同步回调更快）
      const raf = (window && window.requestAnimationFrame) ? window.requestAnimationFrame : null;
      const schedule = (cb) => (raf ? raf(cb) : setTimeout(cb, 0));
      schedule(() => {
        try {
          // Android 环境进入页面时，调用原生权限检查（触发原生定位并回调 H5）
          this.checkCallHelpPermission();
          // 开始获取位置信息（拿到详细地址后再进入 5 秒倒计时）
          this.startLocationFetch();
        } catch (e) {
          // 避免因 WebView 环境差异导致进入页面直接 Script error
          console.warn('mounted 初始化失败:', e);
        }
      });
    });
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this._locationTimeout) {
      clearTimeout(this._locationTimeout);
    }
    // 移除 iOS 原生回调，避免组件销毁后仍被调用
    if (window.iosCoordinates) {
      window.iosCoordinates = null;
    }
    // 移除 Android 原生回调，避免组件销毁后仍被调用
    if (window.iosCoordinates) {
      window.iosCoordinates = null;
    }
    
    // 恢复页面背景色
    document.body.style.backgroundColor = '';
  },
  methods: {
    /**
     * Android 原生：检查一键救援相关权限
     * 仅在大救星 App Android 环境调用
     * @returns {void}
     */
    checkCallHelpPermission() {
      try {
        if (this.$env && this.$env.inDjxApp && this.$env.inAndroid) {
          if (window.JSInterface && typeof window.JSInterface.checkCallHelpPermission === 'function') {
            console.log('调用原生方法 checkCallHelpPermission')
            window.JSInterface.checkCallHelpPermission();
          } else if (typeof JSInterface !== 'undefined' && typeof JSInterface.checkCallHelpPermission === 'function') {
            console.log('调用原生方法 checkCallHelpPermission')
            JSInterface.checkCallHelpPermission();
          } else {
            console.warn('未找到原生方法 checkCallHelpPermission');
          }
        }
      } catch (error) {
        console.warn('调用原生 checkCallHelpPermission 失败:', error);
      }
    },
    /**
     * iOS 原生回调：接收 getCoordinates 返回的坐标并更新页面
     * 原生返回的坐标为火星坐标系（GCJ-02），直接用于取址与提交，不做转换
     * @param {number|string|Object} lngOrData - 经度，或 JSON 字符串，或 { lng, lat } / { longitude, latitude }
     * @param {number} [lat] - 纬度（当第一参数为经度时）
     */
    iosCoordinates(lngOrData, lat) {
      try {
        let lng;
        let latVal;
        // 兼容：原生可能回传 number / string / JSON string / object
        if ((typeof lngOrData === 'number' || typeof lngOrData === 'string') && (typeof lat === 'number' || typeof lat === 'string')) {
          lng = lngOrData;
          latVal = lat;
        } else if (typeof lngOrData === 'string') {
          // 兼容两种情况：
          // 1) JSON 字符串：{"lng":"116.3","lat":"39.9"} 或 {"longitude":...,"latitude":...}
          // 2) 仅经度字符串（此时第二参数可能为空或未传）
          try {
            const data = JSON.parse(lngOrData);
            lng = data.lng || data.longitude;
            latVal = data.lat || data.latitude;
          } catch (e) {
            lng = lngOrData;
            latVal = lat;
          }
        } else if (lngOrData && typeof lngOrData === 'object') {
          lng = lngOrData.lng || lngOrData.longitude;
          latVal = lngOrData.lat || lngOrData.latitude;
        }
        if (lng == null || latVal == null || isNaN(lng) || isNaN(latVal)) {
          console.warn('iosCoordinates 参数无效:', lngOrData, lat);
          return;
        }
        // 转成 number
        let lngNum = Number(lng);
        let latNum = Number(latVal);
        console.log(lngNum,latNum,'236行，原生返回坐标')
        /**
         * 兼容 iOS 原生参数顺序反了的情况：
         * - 正常：lng ∈ [-180,180] 且 lat ∈ [-90,90]
         * - 若检测到第一个更像纬度、第二个更像经度，则交换
         */
        const looksLikeLat = (v) => typeof v === 'number' && isFinite(v) && v >= -90 && v <= 90;
        const looksLikeLng = (v) => typeof v === 'number' && isFinite(v) && v >= -180 && v <= 180;
        if (looksLikeLat(lngNum) && looksLikeLng(latNum) && !looksLikeLat(latNum)) {
          const tmp = lngNum;
          lngNum = latNum;
          latNum = tmp;
          console.warn('检测到经纬度顺序可能反了，已自动交换为 (lng,lat):', lngNum, latNum);
        }

        console.log('原生返回坐标（GCJ-02）:', lngNum, latNum);
        this.onLocationSuccess({ lng: lngNum, lat: latNum });
      } catch (error) {
        console.warn('iosCoordinates 处理失败:', error);
      }
    },
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 取消一键救援倒计时，返回上一页
     * @returns {void}
     */
    cancelRescue() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      if (this.$toast) {
        this.$toast('已取消一键救援');
      } else if (this.$message) {
        this.$message.success('已取消一键救援');
      }
      this.$router.go(-1);
    },
    /**
     * 地址就绪后开始 5 秒倒计时
     * @returns {void}
     */
    startCountdownAfterAddress() {
      if (this.countdownTimer || this.showMainCountdown) return;
      this.showMainCountdown = true;
      this.countdown = 5;
      this.startMainCountdown();
    },
    /**
     * 开始主倒计时（5秒）
     */
    startMainCountdown() {
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          // 倒计时结束，触发救援服务
          this.triggerRescue();
        }
      }, 1000);
    },
    /**
     * 初始化权益统计：二级页 sessionStorage 优先，缺失时补查接口
     * caseType=110（首页一键救援）多数场景不携带权益字段
     * @returns {Promise<void>}
     */
    async initEquityUsedInfo() {
      const caseType = this.rescueCaseType;
      if (caseType === '110') {
        this.equityUsedInfo = null;
        return;
      }

      // 不清除 storage，提交成功后再清，避免倒计时前刷新丢失
      const cached = loadRescueEquityInfo({ clear: false });
      if (cached) {
        this.equityUsedInfo = this.normalizeEquityInfo(cached);
        return;
      }

      const productId = this.$route.query.productId;
      if (productId == null || productId === '') {
        console.warn('[initEquityUsedInfo] 无暂存权益且缺少 productId，跳过补查');
        return;
      }

      try {
        const res = await getEquityUsedCount({ productId, caseType });
        if (res && (res.code === '1000' || res.code === 1000) && res.data) {
          this.equityUsedInfo = this.normalizeEquityInfo(res.data);
        }
      } catch (e) {
        console.error('[initEquityUsedInfo] 补查权益统计失败:', e);
      }
    },
    /**
     * 规范化权益统计字段
     * @param {Object} data
     * @returns {Object}
     */
    normalizeEquityInfo(data) {
      return {
        ...data,
        billingType: normalizeBillingType(data.billingType),
        usedCount: data.usedCount != null ? Number(data.usedCount) : 0,
        timesCount:
          data.timesCount != null && data.timesCount !== ''
            ? Number(data.timesCount)
            : null
      };
    },
    /**
     * 触发救援服务
     * 提交一键救援：caseType +（服务入口）权益统计字段透传云平台 rescueOrderInfo
     */
    async triggerRescue() {
      console.log('倒计时结束，启动一键救援服务');
      
      // 检查是否有位置信息
      if (!this.baiduLocation || !this.baiduAddress) {
        this.$message && this.$message.error('位置信息未获取完成，请稍候再试');
        return;
      }
      
      // 检查地址是否有效
      if (this.baiduAddress === '正在获取中...' || this.baiduAddress === '地址解析失败' || !this.baiduAddress.trim()) {
        this.$message && this.$message.error('地址信息不完整，无法提交救援请求');
        return;
      }
      
      try {
        const caseType = this.rescueCaseType;
        /** @type {Record<string, *>} */
        const rescueData = {
          lat: this.baiduLocation.lat,
          lon: this.baiduLocation.lng,
          address: this.baiduAddress,
          caseType
        };

        // 非 110：透传权益统计（与 equity-used-count 响应对齐，仅非空字段）
        if (caseType !== '110') {
          if (!this.equityUsedInfo) {
            await this.initEquityUsedInfo();
          }
          Object.assign(rescueData, buildRescueEquityPayload(this.equityUsedInfo));
        }
        
        console.log('提交救援请求:', rescueData, {
          from: this.$route.query.from || 'unknown',
          routeCaseType: this.$route.query.caseType
        });
        
        // 调用提交救援接口 POST /case/v1/app/rescue
        const response = await submitRescue(rescueData);
        
        if (response && (response.code === '1000' || response.code === 1000)) {
          // 提交成功后清除暂存，避免下次误用旧数据
          clearRescueEquityInfo();
          // 提交成功，跳转到救援处理中页面
          this.$router.replace({ name: 'rescueProcessing' });
        } else {
          // 提交失败
          const errorMsg = response.msg || '提交失败，请重试';
          this.$message && this.$message.error(errorMsg);
          console.error('救援请求提交失败:', response);
        }
      } catch (error) {
        console.error('救援请求提交异常:', error);
        this.$message && this.$message.error('提交失败，请稍候再试');
      }
    },
    /**
     * 设置并标记详细地址已获取（只触发一次）
     * @param {string} address - 详细地址
     * @returns {void}
     */
    setResolvedAddress(address) {
      const addr = (address || '').toString().trim();
      if (!addr) return;

      this.baiduAddress = addr;
      this.addressLoading = false;

      if (!this.addressResolved) {
        this.addressResolved = true;
        // 获取到详细地址后再进入倒计时 5 秒
        this.startCountdownAfterAddress();
      }
    },
    /**
     * 开始获取位置信息（多重策略 + 超时兜底）
     *
     * - iOS App：调用原生 getCoordinates，由原生通过 iosCoordinates 回传坐标
     * - Android / 其他：HTML5 → GCJ-02 转换 → 接口取地址；失败则 BMap.Geolocation 兜底；15s 超时
     */
    startLocationFetch() {
      console.log('开始获取位置信息');
      this._locationResolved = false;
      this.addressResolved = false;
      this.addressLoading = true;
      this.baiduAddress = '正在获取中...';

      this._locationTimeout = setTimeout(() => {
        if (!this._locationResolved) {
          console.warn('定位整体超时（15s）');
          this.baiduAddress = '定位超时，请检查定位权限';
          this.addressLoading = false;
        }
      }, 15000);

      // iOS App：使用原生定位，由原生调用 window.iosCoordinates 回传坐标
      if (this.$env && this.$env.inDjxApp && this.$env.inIos) {
        try {
          if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getCoordinates) {
            window.webkit.messageHandlers.getCoordinates.postMessage(null);
            return;
          }
        } catch (error) {
          console.warn('调用 iOS getCoordinates 失败:', error);
        }
        // 降级：未找到 getCoordinates 时走下面通用逻辑
      }

      // Android App：进入页面后已通过 checkCallHelpPermission 触发原生获取坐标，
      // 原生会直接回调 window.androidCoordinates，这里不再主动调用 getCoordinates，避免重复触发。
      if (this.$env && this.$env.inDjxApp && this.$env.inAndroid) {
        return;
      }

      // Android / 非 App：使用百度地图链路（HTML5 + BMap 兜底）
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (this._locationResolved) return;
            const wgs84 = {
              lng: position.coords.longitude,
              lat: position.coords.latitude
            };
            console.log('HTML5定位成功（WGS84）:', wgs84.lng, wgs84.lat);
            this.convertAndResolve(wgs84);
          },
          (error) => {
            if (this._locationResolved) return;
            console.warn('HTML5定位失败，切换百度定位:', error.message || error);
            this.getBaiduLocation();
          },
          {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: 0
          }
        );
      } else {
        console.warn('浏览器不支持Geolocation API，切换百度定位');
        this.getBaiduLocation();
      }
    },

    /**
     * 将 WGS84 坐标通过 BMap.Convertor 转为 GCJ-02（火星坐标）
     * @param {Object} wgs84 - WGS84 坐标 { lng, lat }
     */
    convertAndResolve(wgs84) {
      if (typeof BMap === 'undefined') {
        console.warn('百度地图API未加载，无法转换坐标，兜底BMap定位');
        this.getBaiduLocation();
        return;
      }

      const pointWgs = new BMap.Point(wgs84.lng, wgs84.lat);
      const convertor = new BMap.Convertor();

      // coordType: 1=WGS84, 3=GCJ02, 5=BD09ll
      // WGS84 → GCJ-02（火星坐标）
      convertor.translate([pointWgs], 1, 3, (data) => {
        if (this._locationResolved) return;

        if (data && data.status === 0 && data.points && data.points.length > 0) {
          const gcj02 = data.points[0];
          console.log('WGS84→GCJ-02 转换成功:', gcj02.lng, gcj02.lat);
          this.onLocationSuccess(gcj02);
        } else {
          console.warn('坐标转换失败，status:', data && data.status, '，兜底BMap定位');
          this.getBaiduLocation();
        }
      });
    },

    /**
     * 定位成功后的统一处理：保存坐标 → 后端接口 → 逆地理编码
     * @param {BMap.Point|Object} point - GCJ-02 坐标 { lng, lat }
     */
    onLocationSuccess(point) {
      if (this._locationResolved) return;
      this._locationResolved = true;
      clearTimeout(this._locationTimeout);

      // 这里的 point 统一为 GCJ-02（火星坐标）
      this.baiduLocation = { lng: point.lng, lat: point.lat };

      console.log('========== 定位结果（GCJ-02） ==========');
      console.log('  经度:', point.lng);
      console.log('  纬度:', point.lat);

      // 仅使用后端 findAddress 返回的地址进行展示，不使用百度 Geocoder 逆地理解析
      this.fetchAddressByGcj02(point);
    },

    /**
     * 坐标转换：在百度地图坐标系之间转换
     * @param {Object} point - 坐标 { lng, lat }
     * @param {number} from - 坐标类型：1=WGS84，3=GCJ02，5=BD09ll
     * @param {number} to - 坐标类型：1=WGS84，3=GCJ02，5=BD09ll
     * @returns {Promise<BMap.Point>} 转换后的点
     */
    translatePoint(point, from, to) {
      return new Promise((resolve, reject) => {
        if (typeof BMap === 'undefined') {
          reject(new Error('BMap 未加载'));
          return;
        }
        const convertor = new BMap.Convertor();
        const p = (point instanceof BMap.Point) ? point : new BMap.Point(point.lng, point.lat);
        convertor.translate([p], from, to, (data) => {
          if (data && data.status === 0 && data.points && data.points.length > 0) {
            resolve(data.points[0]);
          } else {
            reject(new Error(`坐标转换失败 status=${data && data.status}`));
          }
        });
      });
    },

    /**
     * 兜底方案：使用 BMap.Geolocation（H5 模式走 IP 定位）
     * 含一次自动重试
     */
    getBaiduLocation() {
      if (typeof BMap === 'undefined') {
        console.error('百度地图API未加载');
        this.baiduAddress = '获取位置信息失败';
        this.addressLoading = false;
        return;
      }

      if (window.location && window.location.protocol === 'https:') {
        this.getBaiduLocalCityLocation();
        return;
      }

      const geolocation = new BMap.Geolocation();

      geolocation.getCurrentPosition(
        async (result) => {
          if (this._locationResolved) return;

          const status = geolocation.getStatus();
          if (status === 0 && result.point) {
            console.log('BMap.Geolocation 定位成功(BD-09):', result.point.lng, result.point.lat);
            try {
              // BMap.Geolocation 返回 BD-09，这里转换成 GCJ-02 作为业务坐标
              const gcj02Point = await this.translatePoint(result.point, 5, 3);
              console.log('BD-09→GCJ-02 转换成功:', gcj02Point.lng, gcj02Point.lat);
              this.onLocationSuccess(gcj02Point);
            } catch (e) {
              console.warn('BD-09→GCJ-02 转换失败，回退使用原点:', e);
              this.onLocationSuccess(result.point);
            }
          } else {
            console.warn('BMap.Geolocation 定位失败，status:', status, '，800ms后重试');

            setTimeout(() => {
              if (this._locationResolved) return;
              const retry = new BMap.Geolocation();
              retry.getCurrentPosition(
                async (retryRes) => {
                  if (this._locationResolved) return;
                  const retryStatus = retry.getStatus();
                  if (retryStatus === 0 && retryRes.point) {
                    console.log('BMap.Geolocation 重试成功(BD-09):', retryRes.point.lng, retryRes.point.lat);
                    try {
                      const gcj02Point = await this.translatePoint(retryRes.point, 5, 3);
                      console.log('BD-09→GCJ-02 转换成功(重试):', gcj02Point.lng, gcj02Point.lat);
                      this.onLocationSuccess(gcj02Point);
                    } catch (e) {
                      console.warn('BD-09→GCJ-02 转换失败(重试)，回退使用原点:', e);
                      this.onLocationSuccess(retryRes.point);
                    }
                  } else {
                    console.warn('BMap.Geolocation 重试失败，status:', retryStatus);
                    this.baiduAddress = `定位失败(${retryStatus})`;
                    this.addressLoading = false;
                  }
                },
                { enableHighAccuracy: false }
              );
            }, 800);
          }
        },
        { enableHighAccuracy: false }
      );
    },

    /**
     * HTTPS / 权限策略兜底：使用 BMap.LocalCity（IP 定位）获取城市中心点（BD-09）
     * 再转换为 GCJ-02 进入后续链路。
     * @returns {void}
     */
    getBaiduLocalCityLocation() {
      if (typeof BMap === 'undefined') {
        this.baiduAddress = '获取位置信息失败';
        this.addressLoading = false;
        return;
      }
      try {
        const localCity = new BMap.LocalCity();
        localCity.get(async (rs) => {
          if (this._locationResolved) return;
          const center = rs && rs.center ? rs.center : null;
          if (center && typeof center.lng === 'number' && typeof center.lat === 'number') {
            try {
              const gcj02Point = await this.translatePoint(center, 5, 3);
              this.onLocationSuccess(gcj02Point);
            } catch (e) {
              this.onLocationSuccess(center);
            }
            return;
          }

          // HTTPS + 权限策略场景下，回退到 BMap.Geolocation 仍可能触发 location.html 并被拦截，
          // 这里不再继续触发定位，避免控制台刷 Permissions policy violation。
          this.baiduAddress = '定位失败，请检查定位权限';
          this.addressLoading = false;
        });
      } catch (e) {
        this.baiduAddress = '定位失败，请检查定位权限';
        this.addressLoading = false;
      }
    },

    /**
     * 调用后端 findAddress：使用 GCJ-02（火星坐标）获取详细地址
     * @param {Object} point - GCJ-02 坐标点 { lng, lat }
     */
    async fetchAddressByGcj02(point) {
      try {
        const res = await findAddress({
          lat: Number(point.lat),
          lon: Number(point.lng)
        });

        if (res && (res.code === '1000' || res.code === 1000) && res.data && res.data.address) {
          this.setResolvedAddress(res.data.address);
          console.log('findAddress接口返回地址:', res.data.address);
        } else {
          console.warn('findAddress接口返回异常:', res);
          if (!this.addressResolved) {
            this.addressLoading = false;
            this.baiduAddress = '地址解析失败';
          }
        }
      } catch (error) {
        console.warn('findAddress接口调用失败:', error);
        if (!this.addressResolved) {
          this.addressLoading = false;
          this.baiduAddress = '地址解析失败';
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.rescue-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
  
  /* 顶部导航栏 */
  .rescue-header {
    position: relative;
    width: 100%;
    min-height: 220px;
    overflow: hidden;
    margin-bottom: 0;
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .header-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .header-nav {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    min-height: 44px;
  }

  .nav-back-btn {
    position: fixed;
    left: 16px;
    z-index: 1000;
    width: 28px;
    height: 28px;
    padding: 0;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .nav-back-btn i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .nav-back-btn:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-back-btn:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .nav-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  max-width: calc(100% - 120px);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .nav-placeholder {
    flex-shrink: 0;
    width: 28px;
  }

  /* 内容区域 */
  .rescue-content {
    width: 100%;
    padding: 20px 16px;
    position: relative;
    margin-top: -230px;
    z-index: 10;
    background-color: transparent;
    box-sizing: border-box;
  }

  /* 紧急信息横幅 */
  .rescue-banner {
    position: relative;
    width: 100%;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
    border-radius: 16px;
    padding: 18px 20px;
    margin-bottom: 24px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.25);
    
    /* 世界地图背景效果 */
    &::before {
      content: '';
      position: absolute;
      top: -20px;
      right: -30px;
      width: 200px;
      height: 200px;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      border-radius: 50%;
      opacity: 0.6;
    }
    
    .banner-text {
      color: #ffffff;
      font-size: 15px;
      line-height: 1.8;
      position: relative;
      z-index: 2;
      font-weight: 400;
      
      .banner-line1 {
        margin-bottom: 6px;
        letter-spacing: 0.5px;
      }
      
      .banner-line2 {
        font-weight: 500;
        letter-spacing: 0.5px;
      }
    }
    
    .banner-arrow {
      position: absolute;
      right: -15px;
      top: 50%;
      transform: translateY(-50%) rotate(-45deg);
      width: 80px;
      height: 80px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      opacity: 0.8;
    }
  }

  /* 用户和位置信息 */
  .rescue-user-info {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 16px;
    padding: 18px;
    margin-bottom: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    
    &:active {
      transform: scale(0.98);
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
    }
    
    .user-info-left {
      margin-right: 16px;
      flex-shrink: 0;
      
      .app-icon-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .app-icon {
          width: 64px;
          height: 64px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          position: relative;
          overflow: hidden;
          background: #ffffff;
          
          .app-icon-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
          }
        }
        
        .app-version {
          background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
          color: #333333;
          font-size: 11px;
          padding: 3px 8px;
          border-radius: 6px;
          font-weight: 600;
          box-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
          letter-spacing: 0.5px;
        }
      }
    }
    
    .user-info-right {
      flex: 1;
      min-width: 0;
      
      .user-phone {
        font-size: 17px;
        color: #333333;
        margin-bottom: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
      }
      
      .location-info {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666666;
        line-height: 1.5;
        
        .location-text {
          flex: 1;
          min-width: 0;
          word-break: break-all;
        }

        .location-text-loading {
          color: #999999;
          position: relative;
          padding-right: 6px;
        }

        .location-text-loading::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -2px;
          height: 2px;
          background: linear-gradient(90deg, rgba(74, 144, 226, 0.05) 0%, rgba(74, 144, 226, 0.35) 50%, rgba(74, 144, 226, 0.05) 100%);
          background-size: 200% 100%;
          animation: locationShimmer 1.2s linear infinite;
        }
        
        .location-icon {
          font-size: 20px;
          color: #4A90E2;
          margin-left: 10px;
          flex-shrink: 0;
          animation: pulse 2s ease-in-out infinite;
        }
      }

      .location-detail {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #F0F0F0;
        display: flex;
        flex-direction: column;
        gap: 6px;

        .location-detail-row {
          display: flex;
          align-items: flex-start;
          gap: 6px;
          font-size: 12px;
          line-height: 1.4;
          color: #666666;
        }

        .detail-label {
          flex-shrink: 0;
          color: #999999;
        }

        .detail-value {
          flex: 1;
          min-width: 0;
          color: #333333;
          word-break: break-all;
        }
      }
    }
  }
  
  /* 位置图标脉冲动画 */
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.1);
    }
  }

  @keyframes locationShimmer {
    0% { background-position: 200% 0; }
    100% { background-position: 0 0; }
  }

  /* 倒计时区域 */
  .rescue-countdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    margin-bottom: 32px;
    position: relative;

    &.rescue-countdown--compact {
      min-height: 180px;
      margin-bottom: 20px;
    }
    
    .pre-countdown-text {
      font-size: 16px;
      color: #4A90E2;
      font-weight: 500;
      margin-bottom: 24px;
      animation: fadeInOut 1s ease-in-out;
      
      .pre-countdown-number {
        color: #FF6B6B;
        font-weight: 700;
        font-size: 18px;
        margin: 0 2px;
      }
    }
    
    .main-countdown {
      display: flex;
      align-items: baseline;
      justify-content: center;
      position: relative;
      
      /* 圆形背景 */
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 180px;
        height: 180px;
        background: linear-gradient(135deg, rgba(46, 92, 138, 0.2) 0%, rgba(46, 92, 138, 0.1) 100%);
        border-radius: 50%;
        z-index: 0;
        animation: ripple 2s ease-out infinite;
      }
      
      .countdown-number {
        font-size: 100px;
        font-weight: 700;
        color: #2E5C8A;
        line-height: 1;
        position: relative;
        z-index: 1;
        text-shadow: 0 2px 8px rgba(46, 92, 138, 0.3);
        animation: countdownPulse 1s ease-in-out infinite;
        font-family: 'Arial', sans-serif;
      }
      
      .countdown-unit {
        font-size: 24px;
        color: #2E5C8A;
        margin-left: 6px;
        font-weight: 500;
        position: relative;
        bottom: 12px;
        z-index: 1;
        opacity: 0.95;
      }
    }
  }
  
  /* 倒计时动画 */
  @keyframes fadeInOut {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
  
  @keyframes countdownPulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
  
  @keyframes ripple {
    0% {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 0;
    }
  }

  /* 说明文字 */
  .rescue-disclaimer {
    font-size: 13px;
    color: #666666;
    line-height: 1.8;
    text-align: center;
    padding: 16px 20px;
    margin: 0 8px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  /* 取消按钮 */
  .rescue-cancel-wrap {
    margin: 20px 8px 0;
  }

  .rescue-cancel-btn {
    display: block;
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 16px;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%);
    color: #ffffff;
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 0.5px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.35);
    transition: all 0.3s ease;
    -webkit-tap-highlight-color: transparent;

    &:active {
      transform: scale(0.98);
      box-shadow: 0 2px 8px rgba(74, 144, 226, 0.28);
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/rescue/index.vue